// theme.js
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#003366', // dark blue
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#0055aa'
    },
  },
  overrides: {
    MuiTab: {
      root: {
        '&$selected': {
          backgroundColor: '#003366',
          color: '#ffffff',
        },
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: '#003366',
      },
    },
  },
});

export default theme;
